import type { AiProviderPayload } from '@Application/Ai/AiConfiguration/Providers/Actions/aiProvidersFetched';

export type AiProviderUpdatedPayload = AiProviderPayload;

export type AiProviderUpdatedAction = {
	type: 'AI_PROVIDER_UPDATED';
	payload: AiProviderUpdatedPayload;
	accountId: number;
};

export default (payload: AiProviderUpdatedPayload, accountId: number): AiProviderUpdatedAction => ({
	type: 'AI_PROVIDER_UPDATED',
	payload,
	accountId,
});
